import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-lg p-10 rounded-2xl border border-white/10 bg-neutral-900/50 text-center">
        <div className="mx-auto h-16 w-16 grid place-items-center rounded-full bg-neutral-800 text-neutral-300 mb-5">
          <XCircle size={36} />
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-white">Paiement annulé</h1>
        <p className="mt-3 text-neutral-400">Aucun débit n'a eu lieu. Tu peux relancer le paiement quand tu veux.</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/nous-aider" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-yellow-400 text-neutral-900 font-semibold hover:bg-yellow-300 transition-colors">
            <ArrowLeft size={16} /> Retour sur Nous aider
          </Link>
          <Link to="/" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-white/20 text-white hover:border-yellow-400 hover:text-yellow-400 transition-colors">
            Accueil
          </Link>
        </div>
      </div>
    </section>
  );
}
